import FColumnCellMDP from "../FColumnCellMDP";
export default class FCellBtnLinkMDP implements FColumnCellMDP {
  onClick: (item: any) => any;
  color: string | undefined;
  icon: string | undefined;
  label?: string;
  constructor({
    onClick,
    dataSelectorKey,
    color = "green",
    icon,
    label,
  }: {
    onClick: (item: any) => any;
    dataSelectorKey?: string;
    color?: string;
    icon?: string;
    label?: string;
  }) {
    this.onClick = onClick;
    this.color = color;
    this.icon = icon;
    this.label = label;
  }
  // dataSelectorKey: string;
  componentName: string = "FCellBtnLink";
  getMetaData(): object {
    return {
      componentName: this.componentName,
      props: {
        onClick: this.onClick,
        color: this.color,
        icon: this.icon,
        label: this.label,
      },
    };
  }
}
